// Quick backend test
export const testBackend = async () => {
  try {
    const baseURL = 'https://qlnt.caodangytb.edu.vn/api/v1/generate-exams';
    
    const response = await fetch(`${baseURL}/exam-history?page=1&limit=1`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('quanly_truonghoc_token')}`,
        'Content-Type': 'application/json'
      }
    });
    
    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
  } catch (error) {
    throw error;
  }
};
